import { css, html } from 'react-strict-dom';

import Text from './Text';

type Props = {
  title: string;
  subtitle?: string;
};

export default function EmptyState({ title, subtitle }: Props) {
  return (
    <html.div style={styles.wrap}>
      <Text typeface="headline" color="neutral100" as="h2">
        {title}
      </Text>
      {subtitle && (
        <Text typeface="body.regular" color="neutral60">
          {subtitle}
        </Text>
      )}
    </html.div>
  );
}

const styles = css.create({
  wrap: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 4,
    minHeight: '50vh',
    textAlign: 'center',
  },
});
